import{cloneElement as r}from"react";var a=function(a){var e=a.shouldWrap,p=a.wrapper,t=a.children,l=a.altWrapper;return e?r(p,{children:t}):l?r(l,{children:t}):t};export{a as default};
